import React  from 'react'
import {findDOMNode} from "react-dom"
import PopoverComponent, {PopoverComponentProps, PopoverComponentState} from "../../../../gd-components/base-component/popover-component"

import HintPopover from "../../../../gd-ui/hint-popover/hint-popover"
import Popover from "../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../gd-components/gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../../gd-components/gd-popover/@const"
import TextEditPopoverForm from "../../components/text-edit/text-edit-popover-form"

import Classes from 'classnames'

type Props = PopoverComponentProps & {
    renderMode?        : 'list' | 'view'

    placeholder?       : string
    item               : any
    disabled?          : boolean
    className?         : string

    onChange?          : callback

    attachment?        : string
    targetAttachment?  : string
    targetOffset?      : string
    attachmentType?    : PopoverAttachmentType | 'full'| 'vertical'| 'horizontal'
}

type State = PopoverComponentState & {
    comments : any
}

export default class CommentsProto extends PopoverComponent<Props, State> {

    constructor(props:Props) {
        super(props)

        this.state = _.assign(this.state, {
            comments: this.props.item.statusComments
        })
    }

    componentDidUpdate(prevProps:Props, prevState:State) {
        if (prevState.comments !== this.props.item.statusComments) {
            this.setState({
                comments: this.props.item.statusComments
            })
        }
    }

    onSave = (value:any) => {
        this.setState({
            showPopover: false,
            comments: value
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false)
            if (this.props.onChange) this.props.onChange(value)
        })
    }

    renderPopover() {
        if (this.state.showPopover) {

            const popoverPosition = new PopoverPosition({
                attachment      : this.props.attachment ? this.props.attachment : 'top center', //defaultProps somehow doesn't work
                targetAttachment: this.props.targetAttachment ? this.props.targetAttachment : 'bottom center',
                targetOffset    : this.props.targetOffset,
                attachmentType  : (this.props.attachmentType ? this.props.attachmentType : 'horizontal') as PopoverAttachmentType,
            })

            return (
                <Popover popoverClass="gd-field-text-edit-popover"
                         className="gd-field-text-edit-popover-container"
                         position={popoverPosition}
                         getTargetFunc={()=>findDOMNode(this)}
                         onClickOutside={()=>{this.hidePopover()}}>

                    <TextEditPopoverForm text={this.props.item.statusComments} onSave={this.onSave}/>

                </Popover>
            )
        }
    }

    render() {
        const classes = Classes("gd-field-comments", this.props.renderMode, this.props.className)
        return (
            <div className={classes} onClick={this.props.disabled ? null : this.togglePopover}>
                {this.state.comments}
                {!this.state.comments && !!this.props.placeholder &&
                <div className="placeholder">{this.props.placeholder}</div>}

                {!this.state.showPopover &&
                <HintPopover parent={this}
                             hint={this.state.comments}
                             checkShowHint={()=> {
                                 const node:any = findDOMNode(this)
                                 return node.clientHeight < node.scrollHeight
                             }}
                             multiline={true}/>}

                {this.renderPopover()}
            </div>
        )
    }
}
